import * as React from "react";
const SvgInsertChartOutlinedSharp = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
    <path d="M9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4zm2 2H5V5h14v14zm2-16H3v18h18V3z" />
  </svg>
);
export default SvgInsertChartOutlinedSharp;
